import { gql } from '@apollo/client';

export const DeleteOrganizationDomains = gql`
  mutation DeleteOrganizationDomains($organizationCode: String!, $domainNames: [String!]) {
    deleteDomains(organizationCode: $organizationCode, domainNames: $domainNames)
  }
`;
